import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@fluentui/react/lib/Icon'
import { ChevronLeft, ChevronRight } from 'react-feather'

const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const data = [
  {
    name: 'AIPJ2',
    image: 'khub_act.svg',
    website: 'www.aipj2.com'
  },
  {
    name: 'Maarif Institute',
    image: 'khub_peacegen.svg',
    website: 'www.maarifinstitute.com'
  },
  {
    name: 'ACT (Aksi Cepat Tanggap)',
    image: 'khub_act.svg',
    website: 'www.act.com'
  },
  {
    name: 'Dompet Dhuafa',
    image: 'khub_peacegen.svg',
    website: 'www.dompetdhuafa.com'
  },
]

const PartnerRow = ({data}) => {
  const [open, setOpen] = React.useState(false)

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr>
      <td>
        <div className="flex lg:items-center py-4 lg:py-0">
          <div
            style={{
              width: '24px',
              height: '24px',
              backgroundColor: '#fff',
              backgroundImage: `url('/images/logos/${data.image}')`,
              backgroundSize: '70%'
            }}
            className="rounded rounded-full bg-center mr-2 bg-no-repeat"
          />
          <div>
            {data.name}
            <div className="lg:hidden">{data.website}</div>
          </div>
        </div>
      </td>
      <td><div className="hidden lg:block">{data.website}</div></td>
      <td className="relative">
        <div className="hidden lg:flex items-center">
          <p className="cursor-pointer underline text-sm text-gray-444 mr-8">
            <Link to="/dashboard/profile/partners/edit">Edit</Link>
          </p>
          <p className="cursor-pointer underline text-sm text-gray-999">Delete</p>
        </div>

        <ChevronLeft className="lg:hidden" onClick={() => setOpen(true)}/>
        {
          open &&
          <div className="flex items-center absolute top-0 right-0 h-full">
            <div
              className="h-full flex items-center justify-end pr-4"
              style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
              onClick={() => setOpen(false)}
            >
              <ChevronRight />
            </div>
            <Link
              className={`bg-primary ${actionButtonClasses}`}
              style={{...actionButtonStyles}}
              to="/dashboard/profile/partners/edit"
            >
              <Edit/>
              <p className="underline mt-2">Edit</p>
            </Link>
            <div
              className={`${actionButtonClasses}`}
              style={{background: '#999', ...actionButtonStyles}}
            >
              <Delete/>
              <p className="underline mt-2">Delete</p>
            </div>
          </div>
        }
      </td>
    </tr>
  )
}

const PartnerTable = () => {
  return (
    <table className="table table--striped">
      <tbody className="text-sm">
        {
          data.map((d, index) => (
            <PartnerRow key={index} data={d}/>
          ))
        }
      </tbody>
    </table>
  )
}

export { PartnerTable }